class RechargeWidget {
  constructor(el, sel) {
    this.el = el;
    this.widgetType = el.getAttribute(sel)
    this.input = el.querySelector("input");
    this.value = this.input.value
    this.inputs = [this.input]
    this.updateAnchor = el.closest('[data-widget-container]').querySelector('[data-ajaxcart-rc-widget-confirm]')
    this.currentValue = this.input.value;
    this.select = el.querySelector("[data-recharge-select]");
    this.selectLabel = el.querySelector("[data-recharge-select-label]");
    this.optionContainer = el.querySelector("[data-recharge-option-container]");
    this.sellingPlanOptions = el.querySelectorAll("[data-recharge-option]");
    this.listItemParent = el.closest("li");
    if (this.listItemParent) {
      this.oneTimePrice = this.listItemParent.querySelector(
        "[data-onetime-price]",
      );
      this.subscriptionPrice = this.listItemParent.querySelector(
        "[data-discount-price]",
      );
    }
  }

  init() {
    this.initRecharge();

    if(this.widgetType !== "in cart") {
      this.initPdpWidget();
      // this.updateLocation(this.currentValue)
    } else {
      this.initCartWidget();
    }
  }

  initRecharge() {
    this.updateLocation(this.currentValue);

    if (this.sellingPlanOptions) {
      this.sellingPlanOptions.forEach((option) => {
        option.addEventListener("click", e => {
          e.preventDefault();
          const value = option.getAttribute("data-value");

          this.inputs.forEach(input => input.value = value);
          this.value = value
          this.currentValue = value;
          this.select.setAttribute('data-current-value', value)

          if(this.widgetType === 'in cart') {
            this.updateHref(this.currentValue)
          } else {
            this.updateLocation(this.currentValue)
          }

          this.selectLabel.innerHTML = option.innerHTML;

          this.optionContainer?.classList.remove("active");

          if (this.oneTimePrice && this.subscriptionPrice) {
            if (this.value) {
              this.oneTimePrice.classList.add("hidden");
              this.subscriptionPrice.classList.remove("hidden");
            } else {
              this.oneTimePrice.classList.remove("hidden");
              this.subscriptionPrice.classList.add("hidden");
            }
          }
        });
      });
    }

    document.body.addEventListener("click", (e) => {
      if (
        e.target !== this.optionContainer &&
        e.target !== this.select &&
        !e.target.closest("[data-recharge-option-container]") &&
        !e.target.closest("[data-recharge-select]")
      ) {
        this.optionContainer?.classList.remove("active");
      }
    });
  }

  updateHref(value) {
    const href = this.updateAnchor.getAttribute('href').split('&selling_plan=')[0];
    this.updateAnchor.setAttribute('href', `${href}&selling_plan=${value}`)
  }

  updateLocation(value) {
    if(!value) {
      window.history.pushState({path:value}, '', `${location.pathname}${location.hash}`)
    } else {
      window.history.pushState({path:value}, '', `${location.pathname}?selling_plan=${value}${location.hash}`)
    }
  }

  initPdpWidget() {
    const form = this.el.closest("form[data-product-form]");
    const radios = form.querySelectorAll('input[type="radio"][name="purchaseType"]');
    const gwpInputs = form.querySelectorAll('[data-gwp-property]');

    const toggleGwp = () => {
      const isSub = form.querySelector('input[name="purchaseType"][value="subscription"]:checked');
      gwpInputs.forEach(input => input.disabled = !isSub);
    };

    if (radios.length > 0) {
      radios.forEach((radio) => {
        radio.addEventListener("change", (e) => {
          if (!e.target.checked) {
            return;
          }

          if (e.target.value == "subscription") {
            if(!this.currentValue) this.currentValue = this.select.getAttribute('data-current-value')
            this.inputs.forEach(input => input.value = this.currentValue);
            this.value = this.currentValue
            this.updateLocation(this.currentValue)
          } else if (e.target.value == "one-time") {
            this.inputs.forEach(input => input.value = "");
            this.value = ""
            this.updateLocation(this.value)
          }

          toggleGwp();

          document.querySelectorAll('[data-price-update-el]').forEach(el => {
            radios.forEach(radio => {
              if(!radio.checked) {
                el.innerHTML = radio.getAttribute('data-price')
              }
            })
          })
        });
      });
    }

    toggleGwp();
  }

  initCartWidget() {
    const radios = this.el.closest('[data-widget-container]').querySelectorAll('input[type="radio"][name="purchaseType"]');

    if (radios.length > 0) {
      radios.forEach((radio) => {
        radio.addEventListener("change", (e) => {
          if (!e.target.checked) {
            return;
          }

          const href = this.updateAnchor.getAttribute('href').split('&selling_plan=')[0];
          if (e.target.value == "subscription") {
            this.updateAnchor.setAttribute('href', `${href}&selling_plan=${this.currentValue}`)
          } else {
            this.updateAnchor.setAttribute('href', `${href}&selling_plan=`)
          }
        })
      })
    }
  }
}

